// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_MaximalCliques from "../Restaumatic.PromotionsEngine.MaximalCliques/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
var Promotion = function (x) {
    return x;
};
var udecodePromotion = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "autoAssignable";
    }
})(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "combineTo";
    }
})(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.udecodePromotionFilter)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "conditions";
    }
})(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.unscrambleDecodePromotionConditions)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "prize";
    }
})(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.unscrambleDecodePromotionPrize)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "promotionId";
    }
})(Restaumatic_Promotions_Types_Id.decodePromotionId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "promotionType";
    }
})(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.unscrambleDecodePromotionType)(Unscramble.decodeRecordNil)))))));
var repeatable = function (v) {
    return Data_Record.getField(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.hasFieldProductPromotionR(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "repeatable";
        }
    })()))(Type_Proxy["Proxy"].value)(v);
};
var numRequiredItems = function (v) {
    return Data_Record.getField(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.hasFieldProductPromotionR(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "numRequiredItems";
        }
    })()))(Type_Proxy["Proxy"].value)(v);
};
var newtypePromotion = {
    Coercible0: function () {
        return undefined;
    }
};
var promotionCombineTo = /* #__PURE__ */ (function () {
    var $37 = Data_Newtype.unwrap();
    return function ($38) {
        return (function (v) {
            return v.combineTo;
        })($37($38));
    };
})();
var promotionConditions = /* #__PURE__ */ (function () {
    var $39 = Data_Newtype.unwrap();
    return function ($40) {
        return (function (v) {
            return v.conditions;
        })($39($40));
    };
})();
var promotionId = /* #__PURE__ */ (function () {
    var $41 = Data_Newtype.unwrap();
    return function ($42) {
        return (function (v) {
            return v.promotionId;
        })($41($42));
    };
})();
var promotionPrize = /* #__PURE__ */ (function () {
    var $43 = Data_Newtype.unwrap();
    return function ($44) {
        return (function (v) {
            return v.prize;
        })($43($44));
    };
})();
var promotionFreebies = function (promo) {
    var v = promotionPrize(promo);
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Freeby) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var promotionTarget = function (promotion) {
    var v = (Data_Newtype.unwrap()(promotion)).conditions;
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion) {
        return Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartTarget.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductPromotion) {
        return Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductTarget.value;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 198, column 3 - line 200, column 40): " + [ v.constructor.name ]);
};
var promotionType = /* #__PURE__ */ (function () {
    var $45 = Data_Newtype.unwrap();
    return function ($46) {
        return (function (v) {
            return v.promotionType;
        })($45($46));
    };
})();
var showPromotion = {
    show: function (promotion) {
        return "Promotion" + ("\x0a{ promotionId:    " + (Data_Show.show(Restaumatic_Promotions_Types_Id.showPromotionId)((Data_Newtype.unwrap()(promotion)).promotionId) + ("\x0a, promotionType:  " + (Data_Show.show(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.showPromotionType)((Data_Newtype.unwrap()(promotion)).promotionType) + ("\x0a, conditions:     " + (Data_Show.show(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.showPromotionConditions)((Data_Newtype.unwrap()(promotion)).conditions) + ("\x0a, prize:          " + (Data_Show.show(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.showPromotionPrize)((Data_Newtype.unwrap()(promotion)).prize) + ("\x0a, combineTo:      " + (Data_Show.show(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.showPromotionFilter)((Data_Newtype.unwrap()(promotion)).combineTo) + ("\x0a, autoAssignable: " + (Data_Show.show(Data_Show.showBoolean)((Data_Newtype.unwrap()(promotion)).autoAssignable) + "\x0a}"))))))))))));
    }
};
var mkPromotionNoneFilter = /* #__PURE__ */ (function () {
    return new Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PromotionIdFilter([  ]);
})();
var mkPromotionIdFilter = /* #__PURE__ */ (function () {
    return Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PromotionIdFilter.create;
})();
var mkPromotion = function (promoId) {
    return function (promoFilter) {
        return function (promoType) {
            return function (conds) {
                return function (prz) {
                    return {
                        promotionId: promoId,
                        promotionType: promoType,
                        conditions: conds,
                        prize: prz,
                        combineTo: promoFilter,
                        autoAssignable: true
                    };
                };
            };
        };
    };
};
var mkProductPromotionRequirements = function (prodFilter) {
    return function (repeat) {
        return function (numReqItems) {
            return {
                productFilter: prodFilter,
                repeatable: repeat,
                numRequiredItems: numReqItems
            };
        };
    };
};
var mkProductPromotion = function (promoId) {
    return function (promoFilter) {
        return function (promoType) {
            return function (reqs) {
                return function (prz) {
                    return mkPromotion(promoId)(promoFilter)(promoType)(new Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductPromotion(reqs))(prz);
                };
            };
        };
    };
};
var mkFreeProducts = function (value) {
    return function (vatRate) {
        return Data_Functor.map(Data_Functor.functorArray)(function (name) {
            return {
                productName: name,
                productValue: value,
                vatRate: vatRate
            };
        });
    };
};
var mkCartPromotion = function (promoId) {
    return function (promoFilter) {
        return function (promoType) {
            return function (reqs) {
                return function (prz) {
                    return mkPromotion(promoId)(promoFilter)(promoType)(new Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion(reqs))(prz);
                };
            };
        };
    };
};
var isTextPromotion = function (promotion) {
    return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionPrize)(promotionPrize(promotion))(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.TextInformation.value);
};
var isProductPromotion = function ($47) {
    return (function (v) {
        return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionTarget)(v)(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductTarget.value);
    })(promotionTarget($47));
};
var isCouponPromotion = function (promo) {
    return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionPrize)(promotionPrize(promo))(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CouponValue.value);
};
var isCartPromotionOf = function (cartPromotionRequirement) {
    return function (promotion) {
        var v = (Data_Newtype.unwrap()(promotion)).conditions;
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion) {
            return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqCartPromotionRequiremen)(v.value0)(cartPromotionRequirement);
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductPromotion) {
            return false;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 212, column 3 - line 214, column 32): " + [ v.constructor.name ]);
    };
};
var isFirstOrderPromotion = /* #__PURE__ */ (function () {
    return isCartPromotionOf(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.FirstOrder.value);
})();
var isLoyaltyPromotion = /* #__PURE__ */ (function () {
    return isCartPromotionOf(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Loyalty.value);
})();
var isCartPromotion = function ($48) {
    return (function (v) {
        return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionTarget)(v)(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartTarget.value);
    })(promotionTarget($48));
};
var isAutoAssignablePromotion = /* #__PURE__ */ (function () {
    var $49 = Data_Newtype.unwrap();
    return function ($50) {
        return (function (v) {
            return v.autoAssignable;
        })($49($50));
    };
})();
var inPromotionFilter = function (promotion) {
    return function (filter) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_Promotions_Types_Id.eqPromotionId)(promotionId(promotion))(filter.value0);
    };
};
var getFirstPromotionFreeby = function (promo) {
    return Control_Bind.join(Data_Maybe.bindMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Array.head)(promotionFreebies(promo)));
};
var genericPromotion = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var freeProductValue = function (v) {
    return Data_Record.getField(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.hasFieldFreeProduct(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "productValue";
        }
    })()))(Type_Proxy["Proxy"].value)(v);
};
var freeProductName = function (v) {
    return Data_Record.getField(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.hasFieldFreeProduct(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "productName";
        }
    })()))(Type_Proxy["Proxy"].value)(v);
};
var getFirstPromotionFreebyName = function (promo) {
    return Data_Functor.map(Data_Maybe.functorMaybe)(freeProductName)(getFirstPromotionFreeby(promo));
};
var isInPromotionFreebies = function (freeby) {
    return function (promo) {
        var v = promotionPrize(promo);
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Freeby) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqString)(freeby)(Data_Functor.map(Data_Functor.functorArray)(freeProductName)(v.value0));
        };
        return false;
    };
};
var findPromotionFreeby = function (freeby) {
    return function (promo) {
        var v = promotionPrize(promo);
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Freeby) {
            return Data_Foldable.find(Data_Foldable.foldableArray)(function (freeProduct) {
                return freeby === freeProductName(freeProduct);
            })(v.value0);
        };
        return Data_Maybe.Nothing.value;
    };
};
var eqPromotion = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotion)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionType))()({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Restaumatic_Promotions_Types_Id.eqPromotionId))()({
        reflectSymbol: function () {
            return "prize";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionPrize))()({
        reflectSymbol: function () {
            return "conditions";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionConditions))()({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionFilter))()({
        reflectSymbol: function () {
            return "autoAssignable";
        }
    })(Data_Eq.eqBoolean)))))
};
var ordPromotion = {
    compare: function (a) {
        return function (b) {
            return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidOrdering)([ Data_Ord.compare(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ordPromotionConditions)(promotionConditions(a))(promotionConditions(b)), Data_Ord.compare(Restaumatic_Promotions_Types_Id.ordPromotionId)(promotionId(a))(promotionId(b)) ]);
        };
    },
    Eq0: function () {
        return eqPromotion;
    }
};
var encodePromotion = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.encodePromotionType)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.encodePromotionPrize)))({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.encodePromotionConditions)))({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.encodePromotionFilter)))({
        reflectSymbol: function () {
            return "autoAssignable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))
};
var defaultPromotionFilter = /* #__PURE__ */ (function () {
    return new Restaumatic_PromotionsEngine_Promotions_Types_Promotion.PromotionIdFilter([  ]);
})();
var decodePromotion = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.decodePromotionType))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId1))())({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.decodePromotionPrize))())({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.decodePromotionConditions))())({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.decodePromotionFilter))())({
        reflectSymbol: function () {
            return "autoAssignable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var canCombineTo = function (promotion) {
    return function (otherPromotion) {
        return Data_Eq.notEq(eqPromotion)(promotion)(otherPromotion) && inPromotionFilter(otherPromotion)(promotionCombineTo(promotion));
    };
};
var canCombineToAll = function (promotion) {
    return function (promotions) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraBoolean))(true)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return canCombineTo(v)(promotion);
        })(promotions));
    };
};
var canCombineWith = function (otherPromotion) {
    return function (promotion) {
        return canCombineTo(promotion)(otherPromotion) && canCombineTo(otherPromotion)(promotion);
    };
};
var canCombineWithAll = function (promotion) {
    return function (promotions) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraBoolean))(true)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return canCombineWith(v)(promotion);
        })(promotions));
    };
};
var canCombineWithAllOthers = function (promotion) {
    return function (promotions) {
        var otherPromotions = Data_Array.filter(function (promo) {
            return Data_Eq.notEq(eqPromotion)(promo)(promotion);
        })(promotions);
        return canCombineWithAll(promotion)(otherPromotions);
    };
};
var combineableClique = function (promotions) {
    var cliques = Restaumatic_PromotionsEngine_MaximalCliques.getMaximalCliques(canCombineWith)(promotions);
    return Data_Maybe.fromMaybe([  ])(Data_Array.head(cliques));
};
var allCombineable = function (promotion) {
    return Data_Array.filter(canCombineWith(promotion));
};
export {
    Promotion,
    allCombineable,
    canCombineTo,
    canCombineToAll,
    canCombineWith,
    canCombineWithAll,
    canCombineWithAllOthers,
    combineableClique,
    defaultPromotionFilter,
    findPromotionFreeby,
    freeProductName,
    freeProductValue,
    getFirstPromotionFreeby,
    getFirstPromotionFreebyName,
    inPromotionFilter,
    isAutoAssignablePromotion,
    isCartPromotion,
    isCartPromotionOf,
    isCouponPromotion,
    isFirstOrderPromotion,
    isInPromotionFreebies,
    isLoyaltyPromotion,
    isProductPromotion,
    isTextPromotion,
    mkCartPromotion,
    mkFreeProducts,
    mkProductPromotion,
    mkProductPromotionRequirements,
    mkPromotion,
    mkPromotionIdFilter,
    mkPromotionNoneFilter,
    numRequiredItems,
    promotionCombineTo,
    promotionConditions,
    promotionFreebies,
    promotionId,
    promotionPrize,
    promotionTarget,
    promotionType,
    repeatable,
    newtypePromotion,
    genericPromotion,
    eqPromotion,
    encodePromotion,
    decodePromotion,
    udecodePromotion,
    ordPromotion,
    showPromotion
};
export {
    PromotionId
} from "../Restaumatic.Promotions.Types.Id/index.js";
export {
    Always,
    CartValue,
    FirstOrder,
    HasCoupon,
    Loyalty,
    Never,
    FreeProduct,
    ProductPromotionRequirements,
    CartPromotion,
    ProductPromotion,
    PromotionIdFilter,
    CouponValue,
    Freeby,
    PercentageDiscount,
    PriceDiscount,
    TextInformation,
    CartTarget,
    ProductTarget,
    InformationOnly,
    RequiresCoupon,
    Standard
} from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
//# sourceMappingURL=index.js.map
